import { useCallback, useEffect, useRef } from 'react'

/**
 * ```ts
 * const isMounted = useIsMounted()
 *
 * if (isMounted()) {
 *   // do something
 * }
 * ```
 */
export const useIsMounted = () => {
  const isMounted = useRef(false) // unmounted by default

  useEffect(() => {
    isMounted.current = true // mounted

    return () => {
      isMounted.current = false // unmounted
    }
  }, [])

  return useCallback(() => isMounted.current, [])
}
